<template>
    <div>
        <table-actions-menu
            position="table-action-menu--low"
            :width="[
                showRemindUser
                    ? 'table-action-menu--only-two'
                    : 'table-action-menu--only-one',
            ]"
        >
            <async-table-action-button
                :callback="showUser"
                :noPremadeMode="true"
                :grid="[
                    showRemindUser
                        ? 'table-action-cell--grid-1of2'
                        : 'table-action-cell--grid-1of1',
                ]"
            >
                <div class="table-action-cell__icon-wrapper">
                    <inline-svg
                        :url="
                            require('../../../../images/actions/protocol.svg')
                        "
                        classes="table-action-cell__icon"
                    >
                    </inline-svg>
                </div>
                <div class="table-action-cell__label">
                    {{ trans('reporting.tooltips.actions.training_protocols') }}
                </div>
            </async-table-action-button>

            <div
                class="table-action-cell table-action-cell--grid-1of2"
                @click="showRemindUserModal"
                v-if="showRemindUser"
            >
                <button>
                    <span class="table-action-cell__icon-wrapper">
                        <inline-svg
                            :url="
                                require('../../../../images/actions/email.svg')
                            "
                            classes="table-action-cell__icon"
                        >
                        </inline-svg>
                    </span>
                    <span class="table-action-cell__label">{{
                        trans('reporting.tooltips.actions.remind_user')
                    }}</span>
                </button>
            </div>
        </table-actions-menu>
    </div>
</template>

<script>
import InlineSvg from '../../../util/inlineSvg.js';
import ReportingActionsRemindUserModal from './ReportingActionsRemindUserModal';
import ReportingUserProtocol from '../ReportingUserProtocol';

export default {
    props: ['data', 'index'],

    components: {
        InlineSvg,
    },

    computed: {
        showRemindUser() {
            return (
                this.data.status != 'completed' &&
                this.data.status != 'not_assigned'
            );
        },
    },

    methods: {
        showUser() {
            this.$modal.show(
                ReportingUserProtocol,
                { user_id: this.data.id },
                {
                    height: 'auto',
                    width: '80%',
                    adaptive: true,
                    pivotY: 0.3,
                    scrollable: true,
                }
            );
        },
        showRemindUserModal() {
            this.$modal.show(
                ReportingActionsRemindUserModal,
                { user: this.data },
                { scrollable: true }
            );
        },
    },
};
</script>
